<template>
    <el-dialog title="Sharing Settings"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <h3>Who sees this list view?</h3>
        <div class="cd-section">
            <el-radio label="public" v-model="form_availability">All users can see this list view</el-radio>
        </div>
        <div class="cd-section">
            <el-radio label="private" v-model="form_availability">Only I can see this list view</el-radio>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'view_id',
            'availability'
        ],
        data() {
            return {
                form_availability: 'public'
            };
        },
        watch: {
            availability() {
                this.form_availability = this.availability;
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                return axios.post(url(`admin/views/sharing-settings`), {
                        view_id: this.view_id,
                        availability: this.form_availability
                    }).then(() => {
                        this.$emit('updated');
                        this.showForm = false;
                    });
            }
        }
    }
</script>

<style scoped>
</style>